// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentAccumulatorModel {
    static getAttributeTypeMap() {
        return EnrollmentAccumulatorModel.attributeTypeMap;
    }
}
EnrollmentAccumulatorModel.discriminator = undefined;
EnrollmentAccumulatorModel.additionalProperties = false;
EnrollmentAccumulatorModel.attributeTypeMap = [
    {
        "name": "medications",
        "baseName": "medications",
        "type": "Array<EnrollmentMedicationModel>"
    },
    {
        "name": "medicationMaxBenefit",
        "baseName": "medicationMaxBenefit",
        "type": "number"
    },
    {
        "name": "remainingMedicationBenefit",
        "baseName": "remainingMedicationBenefit",
        "type": "number"
    },
    {
        "name": "totalMedicationPaid",
        "baseName": "totalMedicationPaid",
        "type": "number"
    },
];
//# sourceMappingURL=enrollmentAccumulatorModel.js.map